export default {
  apiGateway: {
    REGION: 'us-east-2',
    URL: 'https://tsdml6lr66.execute-api.us-east-2.amazonaws.com/prod'
  }
}
